import apiClient from "./config";

const bannerService = {
  // Get all banners
  getAllBanners: async () => {
    try {
      const response = await apiClient.get("/banners");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get banner by ID
  getBannerById: async (bannerId) => {
    try {
      const response = await apiClient.get(`/banners/${bannerId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create new banner
  createBanner: async (bannerData) => {
    try {
      const response = await apiClient.post("/banners", bannerData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update banner
  updateBanner: async (bannerId, bannerData) => {
    try {
      const response = await apiClient.put(`/banners/${bannerId}`, bannerData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete banner
  deleteBanner: async (bannerId) => {
    try {
      const response = await apiClient.delete(`/banners/${bannerId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default bannerService;
